/**
 * Which local printer receipts go to.
 *
 * Customer receipts, Z-reports, shift reports, credit notes and PRA invoices
 * all print to the "counter" printer. By default that is the OS default
 * printer; this lets an operator pick a specific device on this machine
 * instead. Width follows the global receipt settings.
 *
 * Stored per-machine in localStorage — a till and a back-office PC on the same
 * tenant can each point at their own hardware.
 *
 * (Split out of the old per-station KOT printer map in F-RETAIL-11; retail has
 * one printer role, not a station routing table.)
 */
const RECEIPT_KEY = 'bhookly-receipt-printer'

export function getReceiptPrinter(): string {
  if (typeof window === 'undefined') return ''
  try {
    return window.localStorage.getItem(RECEIPT_KEY) || ''
  } catch {
    return ''
  }
}

export function setReceiptPrinter(device: string): void {
  if (typeof window === 'undefined') return
  try {
    const d = (device || '').trim()
    if (d) window.localStorage.setItem(RECEIPT_KEY, d)
    else window.localStorage.removeItem(RECEIPT_KEY)
  } catch {
    // non-fatal — falls back to the OS default printer
  }
}
